import React from 'react';
import useApiUrl from '../../../framework/hooks/useApiUrlHook';
import HotspotsMap from '../../../components/maps/HotspotsMap';
import Image from '../../../components/Image';

function getCount(i) {
    console.log(`count${i}`);
    switch (i) {
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
            return 'three';
    }
}

export default function HotspotDetailTemplate1({ data }) {
    const apiUrl = useApiUrl();
    // console.log(data.hotspot);
    return (
        <>
            <div className="shape-wrapper">
                {/* Start Schildkerk Area */}
                <div className="schildkerk-area style-four">
                    <div className="container">
                        <div className="row align-items-top">
                            <div className="col-lg-6" data-aos="fade-up" data-aos-duration={1000}>
                                <div className="schildkerk-content">
                                    <a href={`/hotspots/${data?.hotspot?.location_url}`}>
                                        <span className="top-title">Terug naar overzicht</span>
                                    </a>
                                    <h2>{data.hotspot?.titel}</h2>
                                    <div className="navigeer-btn">
                                        <a
                                            href={`https://www.google.com/maps/place/${data.hotspot?.lat},${data.hotspot?.lon}`}
                                            target="_blank"
                                            className="store-btn"
                                            rel="noreferrer"
                                        >
                                            <img src="/assets/images/marker.svg" alt="navigeer" />
                                            <span>Navigeer naar {data.hotspot?.titel}</span>
                                        </a>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: data.hotspot?.omschrijving }} />
                                    <div className="google-apple">
                                        {data?.hotspot?.mp3_file && (
                                            <a
                                                target="_blank"
                                                href={`/download/redirect/hotspots/${data?.hotspot?.mp3_file}`}
                                                className="store-btn"
                                                rel="noreferrer"
                                            >
                                                <img src="/assets/images/icon/voliom.svg" alt="google" />
                                                <span>Laat tekst voorlezen</span>
                                            </a>
                                        )}
                                        {data?.hotspot?.gpx_file && (
                                            <a
                                                target="_blank"
                                                href={`/download/hotspots/${data?.hotspot?.gpx_file}`}
                                                className="store-btn"
                                                rel="noreferrer"
                                            >
                                                <img src="/assets/images/icon/doc.svg" alt="apple" />
                                                <span>Open GPX bestand</span>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {data?.images?.length > 0 && (
                                <div className="col-lg-6" data-aos="fade-up" data-aos-duration={1000}>
                                    <div
                                        className={`schildkerk-img ${getCount(
                                            data?.images?.length,
                                        )} text-center text-lg-end bottom-style`}
                                    >
                                        {data?.images?.map((img, i) => (
                                            <div key={i} className={`schildkerk ${getCount(i + 1)}`}>
                                                <Image
                                                    src={`${apiUrl}/img/exact/bezienswaardigheden/middel/600/450/80/${
                                                        img.image ?? '/a'
                                                    }`}
                                                    alt=""
                                                />
                                            </div>
                                        ))}
                                        <div className="location">
                                            <Image src="/assets/images/location.svg" alt="location-3" />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* data?.images?.length > 0 && (
                                <div className="col-lg-6" data-aos="fade-up" data-aos-duration={1000}>
                                    <Image
                                        src={`${apiUrl}/img/exact/bezienswaardigheden/middel/600/450/80/${data?.images?.[0].image}`}
                                        className="d-lg-none m-img"
                                        alt=""
                                    />
                                    <div className="schildkerk-img text-end bottom-style d-none d-lg-block">
                                        <div className="schildkerk two">
                                            <Image
                                                src={`${apiUrl}/img/exact/bezienswaardigheden/middel/600/450/80/${data?.images?.[0].image ?? '/a'}`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="location">
                                            <img src="/assets/images/location.svg" alt="location-3" />
                                        </div>
                                    </div>
                                </div>
                            ) */}
                        </div>
                    </div>
                </div>
                {/* End Schildkerk Area */}
                {/* Start Romaanse Area */}
                <div className="romaanse-area bg-color-f4f9ed pt-100 pb-100">
                    <div className="container">
                        <div className="romaanse-content">
                            {data?.hotspot?.quote && <h3>“{data?.hotspot?.quote}”</h3>}
                        </div>
                    </div>
                </div>
                <div className="container  mt-5">
                    <div className="row justify-content-center text-center">
                        <h3 className="mb-5">Bekijk alle hotspots in de buurt</h3>
                        {data?.hotspot?.nearby?.map((item) => (
                            <a
                                key={item.id}
                                href={`/hotspots/${data?.hotspot?.location_url}/${item.url}`}
                                className="col"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                                data-distance={item.distance}
                            >
                                <div className="single-bekijeck text-center">
                                    <Image
                                        src={
                                            item.images?.[0]
                                                ? `${apiUrl}/img/exact/bezienswaardigheden/middel/600/450/80/${item.images?.[0]}`
                                                : '/assets/images/placeholder.jpg'
                                        }
                                        alt={item.titel}
                                    />
                                    <div className="bekijeck-content">
                                        <h3>{item.titel}</h3>
                                        <span>{data?.hotspot?.location}</span>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
                {/* End Romaanse Area */}
                <div className="left-rightbtn-area pb-100 overflow-hidden pt-2 mt-2">
                    <div className="container">
                        <div className="d-flex justify-content-between">
                            <div className="right-container" data-aos="fade-right" data-aos-duration={1000}>
                                <a href={`/hotspots/${data?.hotspot?.location_url}`}>
                                    <button className="right-container-button right-container-button-force w-323">
                                        <span className="short-text">
                                            <i className="ri-arrow-left-s-line" id="icon-chat" />
                                        </span>
                                        <span className="long-text show-long-text">Terug naar overzicht</span>
                                    </button>
                                </a>
                            </div>
                            <div className="right-container" data-aos="fade-left" data-aos-duration={1000}>
                                {data?.hotspot?.next && (
                                    <a href={`/hotspots/${data?.hotspot?.location_url}/${data?.hotspot?.next}`}>
                                        <button className="right-container-button right-container-button-force w-323 green">
                                            <span className="short-text">
                                                <i className="ri-arrow-right-s-line" id="icon-chat" />
                                            </span>
                                            <span className="long-text show-long-text">Volgende Hotspot</span>
                                        </button>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Start Map Video Area */}
                <div className="map-video-area ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6" data-aos="fade-up" data-aos-duration={1000}>
                                <div className="map-content google-map">
                                    <h3>Bekijk alle hotspots van {data?.hotspot?.location}</h3>
                                    <HotspotsMap hotspots={data?.hotspots} location={data?.hotspot?.location_url} />
                                </div>
                            </div>
                            <div className="col-lg-6" data-aos="fade-up" data-aos-duration={1000}>
                                <div className="video-wrap ml-30">
                                    <h3>Beleef {data?.hotspot?.location}</h3>
                                    <iframe
                                        src="https://www.youtube.com/embed/i89EnCl3o2g"
                                        title="YouTube video player"
                                        frameBorder={0}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Map Video Area */}
            </div>
            {/* Start Location video Area */}
            <div className="left-rightbtn-area pb-100 overflow-hidden pt-2">
                <div className="container">
                    <div className="d-flex justify-content-between">
                        <div className="right-container" data-aos="fade-right" data-aos-duration={1000}>
                            <a href={`/hotspots/${data?.hotspot?.location_url}`}>
                                <button className="right-container-button right-container-button-force w-323">
                                    <span className="short-text">
                                        <i className="ri-arrow-left-s-line" id="icon-chat" />
                                    </span>
                                    <span className="long-text show-long-text">Terug naar overzicht</span>
                                </button>
                            </a>
                        </div>
                        <div className="right-container" data-aos="fade-left" data-aos-duration={1000}>
                            {data?.hotspot?.next && (
                                <a href={`/hotspots/${data?.hotspot?.location_url}/${data?.hotspot?.next}`}>
                                    <button className="right-container-button right-container-button-force w-323 green">
                                        <span className="short-text">
                                            <i className="ri-arrow-right-s-line" id="icon-chat" />
                                        </span>
                                        <span className="long-text show-long-text">Volgende Hotspot</span>
                                    </button>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* End Location video Area */}
        </>
    );
}
